import React from "react";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import {
  AppCheckbox,
  DeleteButton,
  EditButton,
  fontFamily,
  paddingAndMargin,
  paginationstyle,
  screenHeaderStyle,
  searchBoxStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";
import { BASE_URL } from "../../App_Settings/app_settings";
import OrganisationModel from "./organisationModel";
import { formatDate } from "../../Utility/utility";
import LoaderIndicator from "../../Utility/loading";
import {
  ConditionalPagination,
  paginationStyles,
  useDynamicRowsPerPage,
} from "../../utils/paginationUtils";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import { useHistory } from "react-router-dom";

const columns = [
  { field: "name", headerName: "Name" },
  { field: "usersCount", headerName: "No.of Users" },
  { field: "createdBy", headerName: "Created By" },
  { field: "createdDate", headerName: "Created Date" },
  { field: "modifiedBy", headerName: "Modified By" },
  { field: "modifiedDate", headerName: "Modified Date" },
  { field: "functions", headerName: "" },
];

export default function Organisation() {
  const [searchValue, setSearchValue] = React.useState("");
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [isInputActive, setInputActive] = React.useState(false);
  const [editingData, setEditingData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [name, setName] = useState(true);
  const [description, setDescription] = useState(true);
  const [loading, setLoading] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [deleteReason, setDeleteReason] = useState("");
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(null);

  // Organization Settings fields
  const [complyAdminUrl, setComplyAdminUrl] = useState("");
  const [pythonAPI, setPythonAPI] = useState("");
  const [sendToAdminAPI, setSendToAdminAPI] = useState("");
  const [complyAdminKey, setComplyAdminKey] = useState("");
  const [autoSuspendUserAfterDays, setAutoSuspendUserAfterDays] = useState(90);

  // Legacy URL fields (for backward compatibility)
  const [frontendUrl, setFrontendUrl] = useState("");
  const [backendUrl, setBackendUrl] = useState("");
  const [adminUrl, setAdminUrl] = useState("");

  const { isMenuOpen, defaultOrganization } = useSharedValue();

  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrtPage] = useState(1); // Current page number
  const { ref: scrollContainerRef, rowsPerPage: dynamicRowsPerPage } = useDynamicRowsPerPage();
  const [endIndex, setEndIndex] = useState(dynamicRowsPerPage);
  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();
  const handleInputFocus = () => {
    setInputActive(true);
  };

  const handleInputBlur = () => {
    setInputActive(false);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setEditingData(null);
    setOpen(false);
  };

  const handleEdit = (row) => {
    setEditingData(row);
    handleOpen();
  };

  const handleSave = (newRow) => {
    // Validate the data before proceeding
    if (!newRow.name || newRow.name.trim() === "") {
      alert("Name is required");
      return;
    }

    if (!newRow.description || newRow.description.trim() === "") {
      alert("Description is required");
      return;
    }

    if (newRow.name.trim().length < 2) {
      alert("Name must be at least 2 characters long");
      return;
    }

    if (newRow.description.trim().length < 5) {
      alert("Description must be at least 5 characters long");
      return;
    }

    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      if (editingData) {
        // For editing, check if the new name conflicts with other organizations (excluding current one)
        const isDuplicate = rows.some(
          (row) =>
            row.id !== editingData.id &&
            row.name.toLowerCase().trim() === newRow.name.toLowerCase().trim()
        );

        if (isDuplicate) {
          alert("An organization with this name already exists. Please choose a different name.");
          return;
        }
        const data = {
          id: editingData.id,
          userId: userData.userId,
          name: newRow.name,
          description: newRow.description,
          modifiedBy: userData.email || userData.userName,
          storageType: newRow.storageType || "BLOB", // Default to BLOB
          pythonAPI: "",
          autoSuspendUserAfterDays: newRow.autoSuspendUserAfterDays || 90,
        };

        fetch(`${BASE_URL}/Organization`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              // Show alert for non-200 responses
              alert(`Error: Unable to update the organization. Status: ${response.status}`);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
          })
          .then((responseText) => {
            // Fetch latest data from database after successful update
            fetchOrganizations();
            handleClose();
            setEditingData(null);
            alert("Organization updated successfully");
          })
          .catch((error) => {
            console.error("Error updating organization:", error);
            // Don't update local state on error
          });
      } else {
        // For creating new organization, check if name already exists
        const isDuplicate = rows.some(
          (row) => row.name.toLowerCase().trim() === newRow.name.toLowerCase().trim()
        );

        if (isDuplicate) {
          alert("An organization with this name already exists. Please choose a different name.");
          return;
        }

        const data = {
          name: newRow.name,
          description: newRow.description,
          createdBy: userData.email || userData.userName,
          storageType: newRow.storageType || "BLOB", // Default to BLOB
          pythonAPI: "",
          autoSuspendUserAfterDays: newRow.autoSuspendUserAfterDays || 90,
        };

        fetch(`${BASE_URL}/Organization`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              alert(`Error: Unable to create the organization. Status: ${response.status}`);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Try to parse as JSON, but fallback to text if it fails
            return response.text();
          })
          .then((responseText) => {
            // Fetch latest data from database after successful creation
            fetchOrganizations();
            handleClose();
            alert("New organization created successfully");
          })
          .catch((error) => {
            console.error("Error creating organization:", error);
          });
      }
    }
  };
  const handleDelete = () => {
    setIsPopupOpen(false);
    // Find the organization to delete
    const orgToDelete = rows.find(
      (row) => row.userId === selectDeletedItem || row.id === selectDeletedItem
    );
    if (!orgToDelete) return;

    const userDataJSON = localStorage.getItem("token");
    if (!userDataJSON) return;
    const userData = JSON.parse(userDataJSON);

    // Prepare the data for delete
    const data = {
      organizationId: orgToDelete.id,
      userId: orgToDelete.userId || userData.userId,
      isActive: false,
      reason: deleteReason || "Deleted by user",
    };

    fetch(`${BASE_URL}/Organization`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          alert(`Error: Unable to delete the organization. Status: ${response.status}`);
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(() => {
        // Update local state: set isActive to false for the deleted org
        setRows((prevRows) =>
          prevRows.map((row) => (row.id === orgToDelete.id ? { ...row, isActive: false } : row))
        );
        setDeleteReason("");
      })
      .catch((error) => {
        console.error("Error deleting organization:", error);
      });
  };

  const [rows, setRows] = React.useState([]);

  const history = useHistory();

  // Function to fetch all organizations from the database
  const fetchOrganizations = () => {
    setLoading(true);

    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Fetching data from the backend server
      fetch(`${BASE_URL}/Organization/${userData.userId}/${userData.organizationId}`, {
        headers: { Authorization: `Bearer ${getUserIdFromLocalStorage().token}` },
      })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);

          setRows(
            data.reverse().filter((row) => {
              // Local search filter (search box on the page)
              const matchesLocalSearch =
                searchValue === "" ||
                (row.name && row.name.toLowerCase().includes(searchValue.toLowerCase())) ||
                (row.createdBy &&
                  row.createdBy.toLowerCase().includes(searchValue.toLowerCase())) ||
                (row.modifiedBy &&
                  row.modifiedBy.toLowerCase().includes(searchValue.toLowerCase()));

              // Global organization filter (Search Organization dropdown)
              const matchesGlobalOrganization =
                !defaultOrganization ||
                row.id === defaultOrganization.id ||
                (row.name && row.name.toLowerCase() === defaultOrganization.name?.toLowerCase());

              return matchesLocalSearch && matchesGlobalOrganization;
            })
          );
          // Here, you can transform the fetched data to match the format of your 'data' array.
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false); // Stop loading in case of error
        });
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, [searchValue, defaultOrganization]);

  const filteredRows = rows.filter(
    (row) =>
      (row.name?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
      (row.createdBy?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
      (row.modifiedBy?.toLowerCase() || "").includes(searchValue.toLowerCase())
  );

  // Do NOT force currentPage back to 1 here, otherwise incidental layout shifts
  // retrigger the ResizeObserver in useDynamicRowsPerPage and silently kick the user back to page 1.
  useEffect(() => {
    setStartIndex((currentPage - 1) * dynamicRowsPerPage);
    setEndIndex((currentPage - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicRowsPerPage]);

  const handlePageChange = (event, newPage) => {
    const page = parseInt(newPage, 10);
    setCurrtPage(page);
    setStartIndex((page - 1) * dynamicRowsPerPage);
    setEndIndex((page - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
  };

  let totalPages = Math.ceil(rows.length / dynamicRowsPerPage);
  return (
    <>
      <div className={screenHeaderStyle(isMenuOpen)}>
        <div
          style={{
            marginTop: paddingAndMargin.headerTopHeight,
            marginBottom: paddingAndMargin.headerBelowHeight,
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <InputBase
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onFocus={() => setInputActive(true)}
            onBlur={() => setInputActive(false)}
            className={searchBoxStyle}
            placeholder="Search Organisation"
            inputProps={{ "aria-label": "Entity Search", style: { padding: "0 8px" } }}
            endAdornment={
              isInputActive || searchValue ? (
                <CloseIcon
                  style={{ cursor: "pointer", color: "#2aa7e0" }}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    setSearchValue("");
                    setInputActive(false);
                  }}
                />
              ) : (
                <SearchIcon style={{ color: "#2aa7e0" }} />
              )
            }
          />
          <Button
            onClick={() => {
              handleOpen();
              setEditingData(null);
            }}
            className="review-btn-outline"
            variant="contained"
          >
            Add Organization
          </Button>
        </div>

        {/* Column Titles */}
        <div class="columntitlesRowStyle">
          <div style={{ paddingRight: "10px" }}>
            <AppCheckbox disabled />
          </div>
          {columns.map((column) => (
            <div key={column.field} class="columntitlesStyle">
              <UpperLowerText text={column.headerName} />
            </div>
          ))}
        </div>

        {/* Main container for table with fixed height */}
        <div style={{ height: "calc(100vh - 220px)", display: "flex", flexDirection: "column" }}>
          {/* Header row - fixed, no scrolling */}
          <div style={{ flexShrink: 0 }}>{/* Header content already rendered above */}</div>

          {/* Scrollable rows container */}
          <div ref={scrollContainerRef} style={{ flex: 1, overflowY: "auto" }}>
            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#555",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LoaderIndicator />
              </div>
            ) : rows.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#555",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                There are no organizations available.
              </div>
            ) : (
              <div>
                {/* Row Data */}
                {(isInputActive ? filteredRows : rows).slice(startIndex, endIndex).map((row) => {
                  const isInactive = row.isActive === false;
                  return (
                    <div
                      key={row.fileImportId || row.id}
                      className="columnRowStyle"
                      style={{
                        backgroundColor: isInactive ? "#f5f5f5" : "white",
                        opacity: isInactive ? 0.6 : 1,
                        color: isInactive ? "#aaa" : undefined,
                      }}
                    >
                      <div style={{ paddingRight: "10px" }}>
                        <AppCheckbox onChange={() => {}} disabled={isInactive} />
                      </div>
                      {columns.map((column) => (
                        <div
                          title={row[column.field]}
                          key={column.field}
                          className="columnValuesStyle"
                          style={{
                            fontWeight: column.field === "usersCount" ? 500 : 300,
                            color: isInactive
                              ? "#aaa"
                              : column.field === "usersCount"
                                ? "blue"
                                : "#424242",
                            cursor:
                              column.field === "usersCount" && !isInactive ? "pointer" : "default",
                          }}
                          onClick={() => {
                            if (column.field === "usersCount" && !isInactive) {
                              history.push({
                                pathname: "/userRoleProfile",
                                state: { organizationId: row.id },
                              });
                            }
                          }}
                        >
                          {column.field === "functions" ? (
                            !isInactive ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  height: 30,
                                }}
                              >
                                <div style={{ marginRight: "auto" }}></div>
                                <EditButton onClick={() => handleEdit(row)} />
                                <DeleteButton
                                  onClick={() => {
                                    setIsPopupOpen(true);
                                    setSelectDeletedItem(row.userId || row.id);
                                  }}
                                  disabled={isInactive}
                                />
                              </div>
                            ) : null
                          ) : column.headerName === "Modified Date" && row[column.field] != null ? (
                            formatDate(row[column.field])
                          ) : column.headerName === "Created Date" ? (
                            formatDate(row[column.field])
                          ) : (
                            row[column.field]
                          )}
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <Modal open={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
          <div
            style={{
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              position: "absolute",
              width: "450px",
              padding: "20px",
              backgroundColor: "white",
              boxShadow: "none",
              borderRadius: "8px",
            }}
          >
            <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily }}>DELETE CONFIRMATION</h6>
            <div
              style={{
                height: "1px",
                width: "100%",
                backgroundColor: "#2aa7e0",
                marginBottom: "20px",
              }}
            ></div>
            <div style={{ marginBottom: "20px", fontFamily: fontFamily }}>
              Are you sure you want to delete this item?
            </div>
            <div style={{ marginBottom: "20px", fontFamily: fontFamily }}>
              <label htmlFor="delete-reason" style={{ display: "block", marginBottom: 4 }}>
                Reason for deletion:
              </label>
              <input
                id="delete-reason"
                type="text"
                value={deleteReason}
                onChange={(e) => setDeleteReason(e.target.value)}
                placeholder="Enter reason (required)"
                required
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleDelete}
                disabled={!deleteReason.trim()}
              >
                Delete
              </Button>
              <Button
                disableElevation
                variant="contained"
                className="cancel-btn-filled"
                onClick={() => {
                  setIsPopupOpen(false);
                  setDeleteReason("");
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal>

        {/* OrganisationModel */}
        <OrganisationModel
          show={open}
          handleClose={handleClose}
          onSave={handleSave}
          editingData={editingData}
        />
      </div>
      <ConditionalPagination
        itemCount={rows.length}
        itemsPerPage={dynamicRowsPerPage}
        threshold={dynamicRowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: paginationstyle,
          sx: paginationStyles,
          hidePrevButton: false,
          hideNextButton: false,
          showFirstButton: true,
          showLastButton: true,
        }}
      />
    </>
  );
}
